import { render, staticRenderFns } from "./TooltipLabel.vue?vue&type=template&id=64c51034&scoped=true"
import script from "./TooltipLabel.vue?vue&type=script&lang=ts"
export * from "./TooltipLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c51034",
  null
  
)

export default component.exports